module.exports = __webpack_public_path__ + "media/assets/images/logo-70d8702e7bcbbb32c021922c8e1fb047.svg";